import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
// pages and components
import ScrollToHash from "./assets/components/parts/ScrollToHash";
import Home from "./pages/Home";

function App() {
  useEffect(() => {
    const onRotate = () =>
      // Chrome Android keeps stale viewport metrics briefly after a rotate;
      // re-fire resize once it settles so measured layouts recompute.
      setTimeout(() => window.dispatchEvent(new Event("resize")), 300);
    window.addEventListener("orientationchange", onRotate);
    return () => window.removeEventListener("orientationchange", onRotate);
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToHash />
        <div className="pages">
          <Routes>
            <Route path="/" element={<Home />} />
          </Routes>
        </div>
      </BrowserRouter>
    </div>
  );
}

export default App;
